"use client";

import { Controller, useWatch } from "react-hook-form";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

export default function Step3Individual({ control, prev, next }) {
  const categories = ["Amateur", "Professional"];

  // Watch the required field
  const individualCategory = useWatch({ control, name: "raceCategory" });
  const isNextEnabled = !!individualCategory;

  return (
    <div
      style={{
        maxWidth: "650px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
      }}
      className="rounded-lg shadow bg-white-1"
    >
      <span className="block py-1 text-center text-base rounded-t-lg font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white-1">
        6th Tour De Sanawar 2025
      </span>

      <div className="w-full h-full p-6 pt-0">
        <div style={{ textAlign: "center",paddingBottom:20 }}>
          <h2
            style={{
              fontSize: "1.875rem",
              fontWeight: "800",
              color: "#1f2937",
            }}
          >
            Individual Participant Details
          </h2>
          <p
            style={{
              marginTop: "0.5rem",
              color: "#6b7280",
              fontSize: "0.875rem",
            }}
          >
            For individual participants, select your race category
          </p>
        </div>

        <div>
          <FormControl fullWidth>
            <InputLabel>Select your race category</InputLabel>
            <Controller
              name="raceCategory"
              control={control}
              render={({ field }) => (
                <Select {...field} label="Select your race category">
                  {categories.map((c) => (
                    <MenuItem key={c} value={c}>
                      {c}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1.5rem",
            gap: 20,
          }}
        >
          <Button variant="outlined" onClick={prev} sx={{
              borderColor: "var(--color-blue)",
              color: "var(--color-blue)",
              "&:hover": {
                borderColor: "var(--color-blue-hover)",
                color: "var(--color-blue-hover)",
              },
            }}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              backgroundColor: "var(--color-blue)",
              "&:hover": { backgroundColor: "var(--color-blue-hover)" },
            }}
            onClick={next}
            disabled={!isNextEnabled}
          >
            Next (Payment)
          </Button>
        </div>
      </div>
    </div>
  );
}
